import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import NIL from "@/pages/NIL";
import Brands from "@/pages/Brands";
import Academy from "@/pages/Academy";
import SuccessStories from "@/pages/SuccessStories";
import Athletes from "@/pages/Athletes";
import AthleteProfile from "@/pages/AthleteProfile";
import Apply from "@/pages/Apply";
import Contact from "@/pages/Contact";
import Nebraska from "@/pages/Nebraska";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AthleteDashboard from "@/pages/dashboards/AthleteDashboard";
import SponsorDashboard from "@/pages/dashboards/SponsorDashboard";
import MgmtDashboard from "@/pages/dashboards/MgmtDashboard";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

// Football
import FootballHome from "@/pages/football/FootballHome";
import Fantasy from "@/pages/football/Fantasy";
import OwnerProfile from "@/pages/football/OwnerProfile";
import NFL from "@/pages/football/NFL";
import College from "@/pages/football/College";
import HighSchoolTop50 from "@/pages/football/HighSchoolTop50";
import HSTeamProfile from "@/pages/football/HSTeamProfile";
import RoadToLeague from "@/pages/football/RoadToLeague";
import SuperBowl from "@/pages/football/SuperBowl";
import FootballNews from "@/pages/football/FootballNews";
import Schedules from "@/pages/football/Schedules";
import Rankings from "@/pages/football/Rankings";
import FootballControlRoom from "@/pages/football/control/FootballControlRoom";

const MGMT_ROLES = ["super_admin","founder","athlete_agent","compliance","finance","social_manager","content_creator"];
const ATHLETE_ROLES = ["athlete", "guardian"];
const SPONSOR_ROLES = ["sponsor"];
const TOASTER_OPTIONS = {
    style: { background: "#0f0f11", border: "1px solid rgba(255,255,255,0.12)", color: "#fff" }
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Toaster theme="dark" position="top-right" toastOptions={TOASTER_OPTIONS} />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/nil" element={<NIL />} />
                        <Route path="/brands" element={<Brands />} />
                        <Route path="/academy" element={<Academy />} />
                        <Route path="/success-stories" element={<SuccessStories />} />
                        <Route path="/athletes" element={<Athletes />} />
                        <Route path="/athletes/:id" element={<AthleteProfile />} />
                        <Route path="/apply" element={<Apply />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/nebraska" element={<Nebraska />} />

                        {/* Football */}
                        <Route path="/football" element={<FootballHome />} />
                        <Route path="/football/fantasy" element={<Fantasy />} />
                        <Route path="/football/fantasy/owners/:slug" element={<OwnerProfile />} />
                        <Route path="/football/nfl" element={<NFL />} />
                        <Route path="/football/college" element={<College />} />
                        <Route path="/football/high-school" element={<HighSchoolTop50 />} />
                        <Route path="/football/high-school/:slug" element={<HSTeamProfile />} />
                        <Route path="/football/road-to-the-league" element={<RoadToLeague />} />
                        <Route path="/football/super-bowl" element={<SuperBowl />} />
                        <Route path="/football/news" element={<FootballNews />} />
                        <Route path="/football/schedules" element={<Schedules />} />
                        <Route path="/football/rankings" element={<Rankings />} />

                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                        <Route path="/payment/cancel" element={<PaymentCancel />} />
                        <Route path="/athlete/dashboard" element={
                            <ProtectedRoute roles={ATHLETE_ROLES}><AthleteDashboard /></ProtectedRoute>
                        } />
                        <Route path="/sponsor/dashboard" element={
                            <ProtectedRoute roles={SPONSOR_ROLES}><SponsorDashboard /></ProtectedRoute>
                        } />
                        <Route path="/mgmt/dashboard" element={
                            <ProtectedRoute roles={MGMT_ROLES}><MgmtDashboard /></ProtectedRoute>
                        } />
                        <Route path="/mgmt/football" element={
                            <ProtectedRoute roles={MGMT_ROLES}><FootballControlRoom /></ProtectedRoute>
                        } />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
